/*
*
* File JS per la Single Magazine
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroPage from 'components/hero-page/hero-page';
import blocksBasicPage from 'components/blocks-basic-page/blocks-basic-page';
import blockNews from 'components/block-news/block-news';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-news.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (evt) =>
{
    blocksBasicPage();
});

//--------------------------------------------------------------------//